import React from 'react';
import { Card, Collapse } from 'antd';
import styled from 'styled-components';
import { AppWrappperHOC } from '../../Root/HOC';
import { Container } from '../../../components';
import { COLLAPSE_MCMD } from './constants';

const { Panel } = Collapse;

const StyledMcmd = styled.section`
  padding:20px 0px;
  ul{
    list-style:none;
    li{
      padding:8px 0px;
      font-size:16px;
      a{
        &:hover{
          color: ${(props) => props.theme.primaryColor};
        }
      }
    }
  }
`;

function MCMD() {
  const {
    MCMD_DETAILS,
  } = COLLAPSE_MCMD;
  return (
    <StyledMcmd>
      <Container>
        <Card>
          <h2>Material contracts and Material Documents</h2>
          <div>
            <i>Note: Capitalised terms not defined herein shall have the meaning ascribed to them in the Red Herring Prospectus dated September 8, 2023 and available at the following web-link: www.zaggle.in/investor-relations.</i>
            <p>
            The copies of the following documents and contracts which have been entered or are to be entered into by our Company which are or may be deemed material have been entered or are to be entered into by our Company. These contracts and also the documents for inspection referred to hereunder, will be attached to the copy of the Red Herring Prospectus filed with the Registrar of Companies, Telangana at Hyderabad, and also be available at the following web-link: www.zaggle.in/investor-relations. Copies of the above-mentioned documents referred to hereunder, may be inspected at the Registered Office of our Company located at 301, III Floor, CSR Estate, Plot No.8, Sector 1, HUDA Techno Enclave, Madhapur Main Road, Hyderabad, Rangareddi 500 081, Telangana, India between 10 a.m. and 5 p.m. on all Working Days from the date of the Red Herring Prospectus until the Bid/Offer Closing Date (except for such agreements executed after the Bid/Offer Closing Date).
            </p>
          </div>
          <Collapse
            expandIconPosition="right"
            bordered={false}
            className="collapse-grill"
          >

            {MCMD_DETAILS && MCMD_DETAILS.map(({ mcmcId, mcmdTitle, subMcmd }) => (
              <Panel
                header={<h1 className="font-16 text-red">{mcmdTitle}</h1>}
                key={mcmcId}
                style={{ border: 'none' }}
              >
                <Collapse
                  expandIconPosition="right"
                  bordered={false}
                  className="collapse-grill"
                >
                  { subMcmd && subMcmd.map(({ subId, subTitle, dataSlug }) => (
                    <Panel
                      header={<h2 className="font-16">{subTitle}</h2>}
                      key={subId}
                    >
                      <ul>
                        { dataSlug && dataSlug.map(({ id, title, link }) => (
                          <li key={id}><a href={link} target="_blank">{title}</a></li>
                        ))}
                      </ul>
                    </Panel>
                  ))}

                </Collapse>
              </Panel>
            ))}

          </Collapse>
          <div>
            Any of the contracts or documents mentioned in the Red Herring Prospectus may be amended or modified at any time if so required in the interest of our Company or if required by the other parties, without reference to the shareholders, subject to compliance with the provisions contained in the Companies Act and other relevant statutes.
          </div>
        </Card>
      </Container>
    </StyledMcmd>
  );
}

const component = AppWrappperHOC(MCMD);

export { MCMD };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/MCMD/index.js